<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100" style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="payTo" id="payTo" type="text" pInputText>
            <label for="payTo">Pay To</label>
            @for (validation of validationMessages.payTo; track validation) {
              <span>
                @if (form1.get('payTo').hasError(validation.type) && (form1.get('payTo').dirty || form1.get('payTo').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="title" id="title" type="text" pInputText>
            <label for="title">Title</label>
            @for (validation of validationMessages.title; track validation) {
              <span>
                @if (form1.get('title').hasError(validation.type) && (form1.get('title').dirty || form1.get('title').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="description" id="description" type="text" pInputText>
            <label for="description">Description</label>
            @for (validation of validationMessages.description; track validation) {
              <span>
                @if (form1.get('description').hasError(validation.type) && (form1.get('description').dirty || form1.get('description').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="statuses" formControlName="srcStatus " optionLabel="name"
            optionValue="value" placeholder="Exp Detail Status"></p-dropdown>
            <label for="Exp Detail Status">Exp Detail Status</label>
            @for (validation of validationMessages.srcStatus ; track validation) {
              <span>
                @if (form1.get('srcStatus').hasError(validation.type) && (form1.get('srcStatus').dirty || form1.get('srcStatus').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="quantity" id="quantity" type="number" pInputText>
            <label for="quantity">Quantity</label>
            @for (validation of validationMessages.quantity; track validation) {
              <span>
                @if (form1.get('quantity').hasError(validation.type) && (form1.get('quantity').dirty || form1.get('quantity').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="amount" id="amount" type="number" pInputText>
            <label for="amount">Amount</label>
            @for (validation of validationMessages.amount; track validation) {
              <span>
                @if (form1.get('amount').hasError(validation.type) && (form1.get('amount').dirty || form1.get('amount').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="taxAmount" id="taxAmount" type="number" pInputText>
            <label for="taxAmount">Tax Amount</label>
            @for (validation of validationMessages.taxAmount; track validation) {
              <span>
                @if (form1.get('taxAmount').hasError(validation.type) && (form1.get('taxAmount').dirty || form1.get('taxAmount').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="taxPct" id="taxPct" type="number" pInputText>
            <label for="taxPct">Tax Pct</label>
            @for (validation of validationMessages.taxPct; track validation) {
              <span>
                @if (form1.get('taxPct').hasError(validation.type) && (form1.get('taxPct').dirty || form1.get('taxPct').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="opsNotes" id="opsNotes" [rows]="2" pInputTextarea></textarea>
            <label for="opsNotes">Ops Notes</label>
            @for (validation of validationMessages.opsNotes; track validation) {
              <span>
                @if (form1.get('opsNotes').hasError(validation.type) && (form1.get('opsNotes').dirty || form1.get('opsNotes').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="ownerNotes" id="ownerNotes" [rows]="2" pInputTextarea></textarea>
            <label for="ownerNotes">Owner Notes</label>
            @for (validation of validationMessages.ownerNotes; track validation) {
              <span>
                @if (form1.get('ownerNotes').hasError(validation.type) && (form1.get('ownerNotes').dirty || form1.get('ownerNotes').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <!---ASK to Josh about this many to one relation will come in dropdwon proprty like this ?-->

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <p-dropdown [options]="properties" formControlName="ownerStmtExpId" optionLabel="propertyCode"
              optionValue="ownerStmtExpId" [filter]="true" filterBy="propertyCode" [showClear]="false"
              placeholder="Select Property of ownerStmtExpId">
            </p-dropdown>
            <label for="Select Property of ownerStmtExpId">Select Property of ownerStmtExpId</label>
            @for (validation of validationMessages.ownerStmtExpId; track validation) {
              <span>
                @if (form1.get('ownerStmtExpId').hasError(validation.type) && (form1.get('ownerStmtExpId').dirty || form1.get('ownerStmtExpId').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <p-dropdown [options]="properties" formControlName="serviceProductId" optionLabel="propertyCode"
              optionValue="serviceProductId" [filter]="true" filterBy="propertyCode" [showClear]="false"
              placeholder="Select Property of serviceProductId">
            </p-dropdown>
            <label for="Select Property of serviceProductId">Select Property of serviceProductId</label>
            @for (validation of validationMessages.serviceProductId; track validation) {
              <span>
                @if (form1.get('serviceProductId').hasError(validation.type) && (form1.get('serviceProductId').dirty || form1.get('serviceProductId').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

      </div>

    </div>

    <div class="row m-0">
      <div class="col-lg-12">
        <div class="btn-group">
          <div class="button-group">
            @if (ownerStmtExpDetailId) {
              <button pButton class="btn-delete p-button-outlined p-button-danger"
              (click)="onFormDelete()">Delete Owner Stmt Exp Detail</button>
            }
          </div>

          <div class="button-group">
            <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
            @if (!ownerStmtExpDetailId) {
              <button pButton class="btn-addt p-button" (click)="formAdd()">Add Owner Stmt Exp Detail</button>
            }

            @if (ownerStmtExpDetailId) {
              <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update Owner Stmt Exp Detail</button>
            }
          </div>
        </div>
      </div>
    </div>

  </div>